import React, { lazy, Suspense } from 'react';
import { isChunkLoadError, reloadForStaleChunk } from './chunkReload';

// A route component that's downloaded only when visited, so the home page
// never pays for the docs. If the file is gone after a deploy, the page
// reloads once to get the new build instead of going blank.
export default function lazyPage(factory) {
    const Page = lazy(() =>
        factory().catch((error) => {
            if (isChunkLoadError(error) && reloadForStaleChunk()) return new Promise(() => {});
            throw error;
        })
    );
    return function LazyPage(props) {
        return (
            <Suspense fallback={<div className="min-h-screen" aria-busy="true" />}>
                <Page {...props} />
            </Suspense>
        );
    };
}
